import { Component, OnInit, AfterViewInit } from '@angular/core';
import { LocationsService } from '../../services/locations/locations.service';
declare var google: any;
import * as $ from 'jquery';

@Component({
  selector: 'locations-map',
  templateUrl: './locations-map.component.html',
  styleUrls: ['./locations-map.component.scss'],
})
export class LocationsMapComponent implements OnInit {
  public mapProps: Object;
  public locationMap: any;
  public googleAPIKey: string = 'AIzaSyACzPyRp1FUIOb2UtVGB-jC3O46q15Dfkw';
  public rodMapOptions = {
    lat: 33.808867,
    lng: -117.840196,
    zoom: 11,
  };

  public locationsIcon: string = './assets/icons/location.svg';
  public locations;
  public locationMarkers = [];

  constructor(private _locationsService: LocationsService) {}

  ngOnInit() {
    (<any>window).googleMapsReady = this.onMapsReady.bind(this);
    var script = document.createElement('script');
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
    script.src =
      'https://maps.googleapis.com/maps/api/js?v=3&key=' +
      this.googleAPIKey +
      '&callback=googleMapsReady';

    this._locationsService.getLocations().subscribe(results => {
      this.locations = results;
      console.log('locations', this.locations);
    });
  }

  onMapsReady() {
    this.mapProps = {
      center: new google.maps.LatLng(
        this.rodMapOptions.lat,
        this.rodMapOptions.lng
      ),
      zoom: this.rodMapOptions.zoom,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      navigationControl: false,
      streetViewControl: false,
      scrollwheel: false,
      zoomControlOptions: {
        style: google.maps.ZoomControlStyle.HORIZONTAL_BAR,
        position: google.maps.ControlPosition.LEFT_CENTER,
      },
      panControl: false,
      mapTypeControl: false,
      fullscreenControl: false,
      styles: [
        {
          featureType: 'administrative',
          elementType: 'labels.text.fill',
          stylers: [
            {
              color: '#444444',
            },
          ],
        },
        {
          featureType: 'landscape',
          elementType: 'all',
          stylers: [
            {
              color: '#f2f2f2',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'all',
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: 45,
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'all',
          stylers: [
            {
              visibility: 'simplified',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'transit',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'all',
          stylers: [
            {
              color: '#4b3d37',
            },
            {
              visibility: 'on',
            },
          ],
        },
      ],
    };

    this.locationMap = new google.maps.Map(
      document.getElementById('landing-location-map'),
      this.mapProps
    );

    this.locations.forEach((location, index) => {
      let { lat, lng } = location;

      var locationPosition = {
        lat,
        lng,
      };

      let locationMarker = new google.maps.Marker({
        position: locationPosition,
        animation: google.maps.Animation.DROP,
        title: "Rodrigo's Mexican Grill",
        icon: this.locationsIcon,
        map: this.locationMap,
      });

      this.locationMarkers.push(locationMarker);

      let { address, phoneNumber } = location;

      let locationInfo = {
        name: "Rodrigo's Mexican Grill",
        address,
        phoneNumber,
      };

      this.attachInfoWindow(locationMarker, locationInfo);
    });

    // for (let i = 0; i < this.locations.length; i++) {
    //   var locationLat = Number(this.locations[i].lat);
    //   var locationLng = Number(this.locations[i].lng);

    //   var locationPosition = {
    //     lat: locationLat,
    //     lng: locationLng,
    //   };

    // let locationIcon = {
    //   url: this.locationsIcon,
    //   size: new google.maps.Size(12.5, 15),
    //   origin: new google.maps.Point(0, 0),
    //   anchor: new google.maps.Point(0, 0)
    // }

    //   let locationMarker = new google.maps.Marker({
    //     position: locationPosition,
    //     animation: google.maps.Animation.DROP,
    //     title: "Rodrigo's Mexican Grill",
    //     icon: this.locationsIcon,
    //     map: this.locationMap,
    //   });

    //   this.locationMarkers.push(locationMarker);

    //   let locationInfo = {
    //     name: "Rodrigo's Mexican Grill",
    //     address: this.locations[i].address,
    //     phoneNumber: this.locations[i].phoneNumber,
    //   };

    //   this.attachInfoWindow(locationMarker, locationInfo);
    // }
  }

  attachInfoWindow(marker, content) {
    var infoCardContent = `
        <div class"location-name"> ${content.name} </div>
        <div class="location-address"> ${content.address} </div>
        <div class="location-phone"> ${content.phoneNumber} </div>
    `;

    // var infoCardContent =
    //   '<div class="location-name">' + content.name + '</div>';
    // infoCardContent +=
    //   '<div class="location-address">' + content.address + '</div>';
    // infoCardContent +=
    //   '<div class="location-phone">' + content.phoneNumber + '</div>';

    var infoCardWindow = new google.maps.InfoWindow({
      content: infoCardContent,
    });

    marker.addListener('click', function() {
      infoCardWindow.open(marker.get('map'), marker);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/landing/locations-map/locations-map.component.ts